export interface AuthConfig {
  MSAL_CLIENT_ID: string;
  MSAL_LOGIN_REDIRECT: string;
  MSAL_LOGOUT_REDIRECT: string;
  MSAL_AUTHORITY: string;
  MSAL_LOGIN_METHOD?: "Redirect" | "Popup";
}

let authConfigStore: AuthConfig | undefined;

export const storeAuthConfig = (authConfig: AuthConfig) => {
  authConfigStore = authConfig;
};

export const getAuthConfig = (): AuthConfig => {
  if (!authConfigStore) throw new Error("Error finding auth configuration");
  return authConfigStore;
};
